import { Dashboard_APIS } from "libs/apis/dashboard.api";
import { useNavigate } from "react-router-dom";

const useDashboard = () => {
  const getDashboard = async (setData: Function) => {
    const response = await Dashboard_APIS.getDashboard();

    if (response) {
      setData(response.data);
    }
  };

  const getNumberOfAttendees = async (
    setDashboardNumberOfAttendees: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await Dashboard_APIS.getNumberOfAttendees(queryParams);

    if (response?.data !== null) {
      setDashboardNumberOfAttendees(response?.data);
      setFilters((prev) => ({
        ...prev,
      }));
    }
  };

  const getNumberOfEventsInLocation = async (
    setNumberOfEventsInLocation: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await Dashboard_APIS.getNumberOfEventsInLocation(
      queryParams
    );

    if (response?.data !== null) {
      setNumberOfEventsInLocation(response?.data);
      setFilters((prev) => ({
        ...prev,
      }));
    }
  };

  const getNumberOfBusinesses = async (
    setNumberOfBusinesses: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await Dashboard_APIS.getNumberOfBusinesses(queryParams);

    if (response?.data !== null) {
      setNumberOfBusinesses(response?.data);
      setFilters((prev) => ({
        ...prev,
      }));
    }
  };

  const getNumberOfBusinessesInIndustry = async (
    setNumberOfBusinessesInIndustry: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await Dashboard_APIS.getNumberOfBusinessesInIndustry(
      queryParams
    );

    if (response?.data !== null) {
      setNumberOfBusinessesInIndustry(response?.data);
      setFilters((prev) => ({
        ...prev,
      }));
    }
  };

  const getNumberOfBusinessesInEachMembership = async (
    setNumberOfBusinessesInEachMembership: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await Dashboard_APIS.getNumberOfBusinessesInEachMembership(
      queryParams
    );

    if (response?.data !== null) {
      setNumberOfBusinessesInEachMembership(response?.data);
      setFilters((prev) => ({
        ...prev,
      }));
    }
  };

  const getCancellationRateByHost = async (
    setCancellationRateByHost: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await Dashboard_APIS.getCancellationRateByHost(
      queryParams
    );

    if (response?.data !== null) {
      setCancellationRateByHost(response?.data);
      setFilters((prev) => ({
        ...prev,
      }));
    }
  };

  const getAmbassadorInEachEngagementLevel = async (
    setAmbassadorInEachEngagementLevel: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await Dashboard_APIS.getAmbassadorInEachEngagementLevel(
      queryParams
    );

    if (response?.data !== null) {
      setAmbassadorInEachEngagementLevel(response?.data);
      setFilters((prev) => ({
        ...prev,
      }));
    }
  };

  const getAmbassadorInEachTier = async (
    setAmbassadorInEachTier: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await Dashboard_APIS.getAmbassadorInEachTier(queryParams);

    if (response?.data !== null) {
      setAmbassadorInEachTier(response?.data);
      setFilters((prev) => ({
        ...prev,
      }));
    }
  };

  const getNumberOfAmbassador = async (
    setNumberOfAmbassador: Function,
    queryParams: any = {},
    setFilters?: Function
  ) => {
    const response = await Dashboard_APIS.getNumberOfAmbassador(queryParams);

    if (response?.data !== null) {
      setNumberOfAmbassador(response?.data);
      setFilters((prev) => ({
        ...prev,
      }));
    }
  };

  return {
    getDashboard,
    getNumberOfAttendees,
    getNumberOfEventsInLocation,
    getNumberOfAmbassador,
    getNumberOfBusinesses,
    getNumberOfBusinessesInIndustry,
    getNumberOfBusinessesInEachMembership,
    getCancellationRateByHost,
    getAmbassadorInEachEngagementLevel,
    getAmbassadorInEachTier,
  };
};

export default useDashboard;
